module.exports = __webpack_public_path__ + "static/media/rasteplass.1deda94e.svg";